<template>
  <a-descriptions v-if="isVisible" title="Management Scope" :column="1" size="small" class="p-0">
    <a-descriptions-item v-for="scope in groupedScopes" :key="scope.type" :label="scope.label">
      {{ scope.value }}
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { Descriptions } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),

    isVisible() {
      return this.groupedScopes.length > 0
    },

    groupedByType() {
      return (this.associate?.manager_scopes || []).reduce((acc, item) => {
        const { object_type } = item

        if (!acc[object_type]) {
          acc[object_type] = []
        }

        acc[object_type].push({
          ...item,
          label: this.formatLabel(object_type)
        })

        return acc
      }, {})
    },

    groupedScopes() {
      return Object.entries(this.groupedByType).map(([type, items]) => ({
        type,
        label: items[0]?.label || this.formatLabel(type),
        value: this.displayItems(items)
      }))
    }
  },

  methods: {
    formatLabel(value = '') {
      return String(value)
        .split('_')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    },

    displayItems(items) {
      return items.map(item => item.name).join(',') || ' - '
    }
  }
}
</script>
